import { FaFacebook } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md text-black">
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
        {/* Date contact */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Date contact</h4>
          <address className="not-italic space-y-2">
            <div>
              Adresa: Ulmeni, str. Petre Dulfu nr. 27, județul Maramureș
            </div>
            <div>
              Telefon:{" "}
              <a
                href="tel:0362405475"
                className="text-[rgb(0,51,51)] font-semibold hover:underline"
              >
                0362405475
              </a>
            </div>
            <div>
              E-mail:{" "}
              <a
                href="mailto:liceul_ulmeni@yahoo.ro"
                className="text-[rgb(0,51,51)] font-semibold hover:underline"
              >
                liceul_ulmeni@yahoo.ro
              </a>
            </div>
          </address>
        </div>

        {/* Adrese utile */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Adrese utile</h4>
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.isjmm.ro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[rgb(0,51,51)] font-semibold hover:underline"
              >
                Inspectoratul Școlar Județean Maramureș
              </a>
            </li>
            <li>
              <a
                href="https://www.edu.ro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[rgb(0,51,51)] font-semibold hover:underline"
              >
                Ministerul Educației și Cercetării
              </a>
            </li>
            <li>
              <a
                href="https://www.ccdmaramures.ro/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[rgb(0,51,51)] font-semibold hover:underline"
              >
                CCD Maramureș
              </a>
            </li>
          </ul>
        </div>

        {/* Ne găsiți și pe */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Ne găsiți și pe</h4>
          <ul className="flex space-x-4">
            <li>
              <a
                href="https://www.facebook.com/tehnologiculmeni.liceul"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="hover:text-[rgb(0,51,51)]"
              >
                <FaFacebook className="text-2xl" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
